<template>
    <div class="learning_main">
        <el-table
            :data="tableData"
            style="
                width: 100%;
                flex: 1;
                border: 1px solid #f2f4f7;
                border-radius: 4px;
            "
            size="medium"
            :header-cell-style="{
                fontWeight: 'normal',
                color: '#333',
                background: '#f5f7fa',
            }"
            class="table-content"
            :cell-style="{ fontSize: '12px', color: '#333' }"
        >
            <el-table-column prop="s_name" label="学生名称"> </el-table-column>
            <el-table-column prop="s_account" label="账号"> </el-table-column>
            <el-table-column label="评定状态">
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.status == 0 ? "未评定" : "已评定" }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="头像" width="250" align="center">
                <template slot-scope="scope">
                    <div>
                        <img class="student-avatar" :src="scope.row.s_ico" alt="" v-if="scope.row.s_ico" />
                        <img class="student-avatar" src="@/assets/images/user_img.png" alt="" style="border-radius: 50%" v-else />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="得分" width="80">
                <template slot-scope="scope">
                    {{ scope.row.score || "-" }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="evaluation(scope.row.s_id)">
                        评定
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                :current-page="pageParams.page"
                :page-size="pageParams.size"
                @current-change="handleCurrentChange"
                background
                layout="prev, pager, next, total"
                :total="pageParams.total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectClassGradId: "",
            tableData: [],
            pageParams: {
                page: 1,
                size: 10,
                paging: 1,
                total: 0,
            },
            total: 0,
        };
    },
    mounted() {
        this.getLiteracyEvaluation();
    },
    methods: {
        // 获取素养评价-学生列表
        getLiteracyEvaluation() {
            const params = {
                c_id: Number(localStorage.getItem("class_id")),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(localStorage.getItem("teacherChapter")),
                course_node: Number(localStorage.getItem("teacherNode")),
                paging: 1,
                page: this.pageParams.page,
                limit: this.pageParams.size,
            };

            this.$shttp.axiosGetBy(this.$api.literacy_student_list, params, (res) => {
                if (res.code === 200) {
                    this.tableData = res.data.list || [];
                    this.pageParams.total = res.data.total;
                }
            });
        },

        evaluation(id) {
            this.$router.push({
                path: "/qualityCourse/teacher/studentLiteracyAssessment",
                query: { s_id: id, course_id: this.$route.query.course_id },
            });
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;
            this.getLiteracyEvaluation();
        },
    },
};
</script>

<style scoped lang="scss">
.learning_main {
    width: 100%;
    padding-top: 20px;
    box-sizing: border-box;
    //   margin-top: 20px;
    background-color: #ffffff;

    .header {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        .class_label {
            padding: 0 22px;
        }
    }

    .student-avatar {
        // width: 64px;
        height: 64px;
        object-fit: cover;
    }

    .pagination {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
    }
}
::v-deep .el-input__inner {
    background: #fff !important;
}
::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #409eff !important;
}
</style>
